export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14471.56d8a075.jpg";